import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';
import Typography from '../typography/Typography';
import { BoxContainer, HelpBoxWrapper, ButtonWrapper, CustomButton, CustomImage, CustomMobileImage, } from './styles';
export const HelpBox = ({ headingText, buttonText, smsIcon, LightEffect, LightEffectMobile, className, }) => {
    const { colors } = useTheme();
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/ticket');
    };
    return (_jsxs(HelpBoxWrapper, { className: className, children: [_jsx(CustomImage, { src: LightEffect }), _jsx(CustomMobileImage, { src: LightEffectMobile }), _jsxs(BoxContainer, { children: [_jsx(Typography, { type: "bodyButton", fontFamily: "primaryBold", color: colors.text.default, children: headingText }), _jsx(ButtonWrapper, { className: "support-button-wrapper", children: _jsx(CustomButton, { type: "submit", title: buttonText, icon: smsIcon, onClick: handleClick, className: "support-button" }) })] })] }));
};
//# sourceMappingURL=HelpBox.js.map